import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from 'antd/locale/zh_CN';

const Display = lazy(() => import('./pages/Display/Display'));
const AiAssistant = lazy(() => import('./pages/AiFloating/AiAssistant'));
const FilePreview = lazy(() => import('./components/FilePreview'));
const Login = lazy(() => import('./pages/Login/Login'));
const Page = lazy(() => import('./pages/index'));

dayjs.locale('zh-cn');

function App() {
  return <div className={'App'}>
    <ConfigProvider
      locale={zhCN}
      renderEmpty={() => '暂无数据'}
    >
      <BrowserRouter>
        {/* todo 优化首次加载时页面闪屏问题 */}
        <Suspense
          fallback={<div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
          >
            <Spin size='large' tip='加载中...' />
          </div>}
        >
          <Routes>
            <Route path={'/display'} element={<Display />} />
            <Route path={'/ai'} element={<AiAssistant />} />
            <Route path={'/file/preview/:id'} element={<FilePreview />} />
            <Route path={'/login'} element={<Login />} />
            {/*<Route path={'/file/import/:hashUrl'} element={<FileImport />} />*/}
            <Route path='/*' element={<Page />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  </div>;
}

export default App;
